import React, { useCallback, useState } from "react";
import ContextGeneral from "./contexto";

function ContextNoticias(props) {
  const [noticias, setNoticias] = useState([]);
  const [estadoUsuario, setEstadoUsuario] = useState(0);
  const [user, setUser] = useState(null);
  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(false);

  const inspectorSesion = useCallback(() => {
    setUser(null);
    setEstadoUsuario(0);
  }, []);

  const llamadaDB = useCallback(async () => {
    setNoticias([]);
    setLoader(true);
  }, []);

  return (
    <ContextGeneral.Provider
      value={{
        loader,
        auth: null,
        user,
        noticias,
        estadoUsuario,
        open,
        setOpen,
        setUser,
        setEstadoUsuario,
        setNoticias,
        inspectorSesion,
        llamadaDB,
      }}
    >
      {props.children}
    </ContextGeneral.Provider>
  );
}

export default ContextNoticias;
